import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
function SocialActive() {
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>Dori turlari texnologiyasi kafedrasi</h4>
            <div className="card__custom">
              <div className="box__custom">
                <img src="img/7.png" alt />
              </div>
              <div className="box-1__custom">
                <p>Ashurova Nigora  Xayitovna</p>
                <span>Yoshlar bilan ishlash, ma`naviyat va ma`rifat bo`limi boshlig`i</span>
                <br />
                <br />
                <hr />
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>E-pochta</p>
                    <span>rektor@pharmi.uz</span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Tel:</p>
                    <span>+998 (71) 256-37-38</span>
                  </div>
                
                </div>
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>Telefon nomer</p>
                    <span>Tibbiyot fanlari doktori</span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Qabul vaqti</p>
                    <span>Seshanba, Payshanba 15:00-17:00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card1__custom">
            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>Kafedra maqsadi:</h4>
            </div>
            <p>
              Dori turlari texnologiyasi kafedrasi Toshkent farmasevtika
              instituti farmasiya fakul'teti tuzilmasining tarkibiy qismi
              hisoblanib, unda o‘quv, o‘quv-uslubiy, ilmiy-tadqiqot hamda
              ma'naviy-ma'rifiy va tarbiyaviy ishlar, shuningdek, ilmiy va
              ilmiy-pedagogik kadrlar tayyorlash ishlari amalga oshiriladi.
            </p>

            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>Kafedra vazifalari:</h4>
            </div>
            <p>
              Talabalarning tanishuv, o‘quv, malakaviy amaliyotlari, magistrlik
              dissertasiyalariga, shuningdek, mustaqil ishlari va ilmiy-tadqiqot
              ishlariga rahbarlik qilish;
            </p>

            <p>
              Talabalar bilimining reyting nazoratini joriy etish va mustaqil
              ishlarini tashkil etish bo‘yicha tadbirlar o‘tkazish
            </p>

            <p>
              Darslik, o‘quv, o‘quv-uslubiy va ko‘rgazmali qurollar,
              qo‘llanmalar tayyorlash, qayta nashr etiladigan darslik, o‘quv
              qo‘llanma va o‘quv-uslubiy adabiyotlar tayyorlash;
            </p>

            <p>
              Kafedra yo‘nalishlari va mutaxassisliklari bo‘yicha MT, o‘quv
              rejalari va dasturlarini rivojlangan horijiy mamlakatlarning
              ta'lim dasturlari bilan qiyosiy tahlilini muntazam ravishda olib
              borish va takomillashtirish;
            </p>
            <p>
              Kafedra fanlari bo‘yicha ishchi o‘quv dasturlarini ishlab chiqish
              va belgilangan tartibda tasdiqqa taqdim yetish, shuningdek turdosh
              kafedralar tomonidan tayyorlangan ishchi o‘quv dasturlariga taqriz
              va xulosalar tayyorlash;
            </p>
            <p>
              Qoloq, muammoli talabalar bilan ishlash, ularni tarbiyalash hamda
              qoloq talabalar safidan chiqarish;
            </p>
            <p>
              Belgilangan tartibda professor-o‘qituvchilarning malakasini
              oshirishni tashkil etish hamda ularning respublika hamda halqaro
              ilmiy anjumanlarda ma'ruzalar bilan ishtirok etishini ta'minlash;
            </p>
            <p>
              Talabalar ilmiy-tadqiqot faoliyatini tizimli asosda tashkil etish,
              iqtidorli talabalarni aniqlash va ularni ilmiy tadqiqotlarga jalb
              yetish, ilmiy-tadqiqot ishlarini individual va jamoa bo‘lib
              bajarishga o‘rgatish, ularning ilmiy-ijodiy faoliyatini ro‘yobga
              chiqarish uchun zarur tashkiliy, uslubiy va moddiy-texnik
              shart-sharoitlar yaratish;
            </p>
          </div>

          <div className="card5__custom">
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
          </div>
        </div>
      </div>
      <div className="mt"></div>
      <Footer />
    </div>
  );
}

export default SocialActive;
